const e = 36, l = [
  "AL",
  "AK",
  "AZ",
  "AR",
  "CA",
  "CO",
  "CT",
  "DE",
  "FL",
  "GA",
  "HI",
  "ID",
  "IL",
  "IN",
  "IA",
  "KS",
  "KY",
  "LA",
  "ME",
  "MD",
  "MA",
  "MI",
  "MN",
  "MS",
  "MO",
  "MT",
  "NE",
  "NV",
  "NH",
  "NJ",
  "NM",
  "NY",
  "NC",
  "ND",
  "OH",
  "OK",
  "OR",
  "PA",
  "RI",
  "SC",
  "SD",
  "TN",
  "TX",
  "UT",
  "VT",
  "VA",
  "WA",
  "WV",
  "WI",
  "WY"
], t = [
  {
    label: "Price",
    key: "price",
    type: "range",
    collapsible: !0,
    collapsed: !1
  },
  {
    label: "Country",
    key: "country",
    type: "radio",
    collapsible: !0,
    collapsed: !0
  },
  {
    label: "Region",
    key: "region",
    type: "checklist",
    collapsible: !0,
    collapsed: !0
  },
  {
    label: "Producer",
    key: "producer",
    type: "checklist",
    collapsible: !0,
    collapsed: !0
  },
  {
    label: "Wine Type",
    key: "wine_type",
    type: "checklist",
    collapsible: !0,
    collapsed: !0
  },
  {
    label: "Blends",
    key: "varietal",
    type: "checklist",
    collapsible: !0,
    collapsed: !0
  },
  {
    label: "Vintage",
    key: "vintage",
    type: "checklist",
    collapsible: !0,
    collapsed: !0
  },
  {
    label: "Size",
    key: "bottle_size",
    type: "checklist",
    collapsible: !0,
    collapsed: !0
  },
  {
    label: "Farming Type",
    key: "farming_type",
    type: "checklist",
    collapsible: !0,
    collapsed: !0
  },
  {
    label: "Stock Status",
    key: "in_stock",
    type: "boolean",
    collapsible: !0,
    collapsed: !0,
    options: [
      {
        checked: !0,
        count: 0,
        label: "Show in stock items only",
        sublabel: ""
      }
    ]
  }
];
export {
  t as D,
  e as M,
  l as S
};
